import { Reducer } from 'redux';
import { Product } from '../models';

export interface State {
    invalidProduct: boolean;
    product?: Product;
    productLoading: boolean;
}

interface SetInvalidProductAction {
    type: 'SET_INVALID_PRODUCT';
    invalidProduct: boolean;
}

interface SetProductAction {
    type: 'SET_PRODUCT';
    product?: Product;
}

interface SetProductLoadingAction {
    type: 'SET_PRODUCT_LOADING';
    productLoading: boolean;
}

type KnownAction = SetInvalidProductAction | SetProductAction | SetProductLoadingAction;

export const actionCreators = {
    setInvalidProduct: (invalidProduct: boolean): SetInvalidProductAction => ({ type: 'SET_INVALID_PRODUCT', invalidProduct }),
    setProduct: (product: Product | undefined): SetProductAction => ({ type: 'SET_PRODUCT', product }),
    setProductLoading: (productLoading: boolean): SetProductLoadingAction => ({ type: 'SET_PRODUCT_LOADING', productLoading })
};

export const reducer: Reducer<State, KnownAction> = (state, action) => {
    if (state === undefined) {
        return {
            invalidProduct: false,
            productLoading: false
        };
    }

    switch (action.type) {
        case 'SET_INVALID_PRODUCT':
            return { ...state, invalidProduct: action.invalidProduct };
        case 'SET_PRODUCT':
            return { ...state, product: action.product };
        case 'SET_PRODUCT_LOADING':
            return { ...state, productLoading: action.productLoading };
        default:
            return state;
    }
};
